module.exports = __webpack_public_path__ + "img/nantucket.57cecbed.jpg";